import { StatusTag } from "@graffer-inc/console-design-kit";

export const ToggleTag: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  if (disabled) {
    return <StatusTag type="ERROR">無効</StatusTag>;
  }
  return (
    <StatusTag hiddenCheckIcon type="SUCCESS">
      有効
    </StatusTag>
  );
};
